var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6708 0.208032C16.9573 0.160258 17.2507 0.175444 17.5307 0.252535C17.8107 0.329625 18.0706 0.46677 18.2922 0.654436C18.5139 0.842102 18.692 1.07579 18.8142 1.33924C18.9364 1.6027 18.9997 1.88961 18.9998 2.18003V14C18.9996 14.8805 18.7089 15.7364 18.1728 16.4348C17.6366 17.1332 16.885 17.6353 16.0345 17.863C15.1839 18.0908 14.282 18.0315 13.4686 17.6944C12.6552 17.3574 11.9757 16.7613 11.5355 15.9987C11.0954 15.2362 10.9191 14.3497 11.0341 13.4767C11.1491 12.6037 11.5489 11.7931 12.1716 11.1705C12.7942 10.548 13.6049 10.1482 14.4779 10.0333C15.3508 9.91844 16.2373 10.0948 16.9998 10.535V6.18003L6.99985 7.84703V15C6.99985 15.06 6.99485 15.118 6.98485 15.174C7.05664 15.943 6.87207 16.7141 6.4599 17.3673C6.04772 18.0204 5.43109 18.5189 4.70607 18.785C3.98105 19.0512 3.18836 19.07 2.45151 18.8386C1.71466 18.6073 1.07502 18.1387 0.632263 17.5059C0.189501 16.8731 -0.0315228 16.1116 0.00362873 15.3401C0.0387802 14.5686 0.328132 13.8303 0.826603 13.2404C1.32507 12.6505 2.00467 12.242 2.75951 12.0786C3.51435 11.9152 4.30203 12.0061 4.99985 12.337V3.84703C4.99979 3.37359 5.16768 2.91549 5.47366 2.55421C5.77964 2.19293 6.20386 1.95191 6.67085 1.87403L16.6708 0.208032ZM6.99985 5.82003L16.9998 4.15303V2.18003L6.99985 3.84703V5.82003Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateMusic);
export default __webpack_public_path__ + "static/media/create-music.9d630bde97bc3a203af124de132a5ef5.svg";
export { ForwardRef as ReactComponent };